<script lang="ts">
	import { Device, DeviceRPi } from "luxedo-data"

	interface Props {
		device: Device;
	}

	let { device }: Props = $props();
	let boostStatus: boolean

	function getHDMIBoostStatus() {
		boostStatus = (device as DeviceRPi)?.eidos?.config?.fw_config?.hdmi_boost ?? false
		return boostStatus
	}

	async function applyHDMIBoost() {
		await device.platoCall("hdmi_boost_apply", [4])
	}

	async function removeHDMIBoost() {
		await device.platoCall("hdmi_boost_remove", [])
	}
</script>

{#if !getHDMIBoostStatus()}
	<button class="small" title="Apply HDMI Fix" onclick={applyHDMIBoost}>Apply HDMI Fix</button>
{:else}
	<button class="small" title="Remove HDMI Fix" onclick={removeHDMIBoost}>Remove HDMI Fix</button>
{/if}

<style>
</style>
